import React, { useMemo } from "react";
import { withRouter } from "react-router-dom";
import NavItemImage from "./NavItemImage";
import NavLogo from "./NavLogo";
import NavUser from "./NavUser";
import NavBurgerMenu from "./NavBurgerMenu";
import LocaleSwitch from "../LocaleSwitch";
import images from "../../images";
import { EnumPaths } from "../../utils/navigation";
import history from "../../history";
import { Display } from "../../components/OperatorCustomization";
import { GroundAuthContextStore } from "../../lib/ground-aws-cognito-auth-core";
import { DisplayConfiguration } from "../../lib/operator-configuration/backoffice/display";

interface NavLink {
  id: string;
  label: string;
  image: string;
  imageHover: string;
  path: string;
  displayPath: (keyof DisplayConfiguration)[];
}

const Navbar = () => {
  const me = GroundAuthContextStore.useStoreState(
    state => state.authentication.me
  );

  const navLinks: NavLink[] = useMemo(
    () => [
      {
        id: "menu-centers",
        label: "navbar.menu.centers",
        image: images.buildings,
        imageHover: images.buildings_white,
        path: EnumPaths.CENTERS,
        displayPath: ["header.centers"],
      },
      {
        id: "menu-providers",
        label: "navbar.menu.providers",
        image: images.providers,
        imageHover: images.providers_white,
        path: EnumPaths.PROVIDERS,
        displayPath: ["header.providers"],
      },
      {
        id: "menu-users",
        label: "general.clients",
        image: images.customers,
        imageHover: images.customers_white,
        path: EnumPaths.USERS,
        displayPath: ["header.users"],
      },
      {
        id: "menu-administrators",
        label: "navbar.menu.administrators",
        image: images.admins,
        imageHover: images.admins_white,
        path: EnumPaths.ADMINISTRATORS,
        displayPath: ["header.administrators"],
      },
      {
        id: "menu-indicators",
        label: "general.indicators",
        image: images.stats,
        imageHover: images.stats_white,
        path: EnumPaths.INDICATORS_USERS,
        displayPath: ["header.indicators"],
      },
      {
        id: "menu-parameters",
        label: "general.parameters",
        image: images.settings,
        imageHover: images.settings_white,
        path: EnumPaths.PAYMENT_METHODS,
        displayPath: ["header.parameters"],
      },
      {
        id: "menu-developers",
        label: "general.developers",
        image: images.dev,
        imageHover: images.dev_white,
        path: EnumPaths.WEBHOOKS,
        displayPath: ["header.developers"],
      },
    ],
    []
  );

  const handleGoTo = (path: string) => {
    localStorage.removeItem("navItem");
    localStorage.removeItem("parentNavItem");
    history.push(`/${EnumPaths.ROOT}/${path}`);
  };

  return (
    <nav className="bg-ground-black-100 shadow fixed w-full z-50">
      <div className="px-2 sm:px-4 lg:px-8">
        <div className="flex justify-between h-20">
          <div className="flex px-2 lg:px-0">
            <NavLogo
              id="logo"
              src={
                me?.operator_id.includes("WOJO") ? images.wojologo : images.logo
              }
              onClick={() => handleGoTo("")}
            />

            <div className="hidden lg:ml-6 lg:flex">
              {navLinks.map((link, idx) => (
                <Display paths={link.displayPath} key={link.id}>
                  <NavItemImage
                    id={link.id}
                    index={idx}
                    label={link.label}
                    onMouseOutImage={link.image}
                    onMouseOverImage={link.imageHover}
                    active={history.location.pathname.startsWith(
                      `/${EnumPaths.ROOT}/${link.path}`
                    )}
                    className={idx > 0 ? "ml-4" : undefined}
                    onClick={() => handleGoTo(link.path)}
                  />
                </Display>
              ))}
            </div>
          </div>
          <NavBurgerMenu />
          <div className="hidden lg:flex lg:items-center space-x-2">
            <LocaleSwitch />
            {me && <NavUser user={me} />}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default withRouter(Navbar);
